export default "__VITE_ASSET__B5PY9oH3__"